export const texts = {
  yes: 'Да',
  no: 'Нет',
  saveEditConfirmation: 'Вы уверены, что хотите сохранить?',
  cancelEditConfirmation: 'Вы уверены, что хотите отменить редактирование?',
  deleteConfirmation: 'Вы уверены, что хотите удалить?',
};
